<script lang="ts">
	//Hooks
	import { createEventDispatcher, onMount, getContext } from 'svelte';
	//Design system components
	import { IconButton, toast } from '@Shelly/shelly-design-system';
	//Helpers
	import { checkGeolocationPosition } from '../../../helpers/geolocalion_helper';
	//Types
	import type { MapContext } from '../../../types/requests/services/weather';
	import { get } from 'svelte/store';
	import { format } from 'svelte-i18n';

	const _format = get(format);

	export let flyToMap = true,
		onLocation = false,
		zoom = 12;

	const { getMap }: MapContext = getContext('map'),
		map = getMap(),
		dispatcher = createEventDispatcher();

	let waitForResponse = false,
		userLocationDotMarker: any;

	onMount(() => {
		map.on('movestart', onStartDrag);
		return () => map.off('movestart', onStartDrag);
	});

	function onStartDrag() {
		onLocation = false;
	}

	function onClickHandler() {
		waitForResponse = true;
		checkGeolocationPosition()
			.then((data: { lng: number; lat: number }) => {
				if (flyToMap) {
					map.flyTo({
						center: [data.lng, data.lat],
						zoom,
						curve: 2,
						easing: (t) => t,
						speed: 1,
					});
				}
				waitForResponse = false;
				setTimeout(() => (onLocation = true), 100);
				if (!userLocationDotMarker) {
					const element = document.createElement('DIV');
					element.classList.add('mapboxgl-user-location-dot');
					//@ts-ignore
					userLocationDotMarker = new mapboxgl.Marker({ element });
				}
				userLocationDotMarker.setLngLat([data.lng, data.lat]).addTo(map);
				dispatcher('change', { lat: data.lat, lon: data.lng });
			})
			.catch((error) => {
				waitForResponse = false;
				if (error?.message) {
					toast.open({
						type: 'warning',
						title: _format('map_geolocation_disabled_error', {
							default: 'Please enable location services on your device and try again.',
						}),
					});
				}
			});
	}
</script>

<div class="location-btn">
	<IconButton
		variant="secondary"
		disabled={onLocation}
		loading={waitForResponse}
		icon={waitForResponse ? '' : 'fas fa-location'}
		aria-label={$format('label_get_location', { default: 'Get current location' })}
		on:click={onClickHandler}
	/>
</div>

<style>
	.location-btn {
		position: absolute;
		bottom: 40px;
		right: 10px;
		box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.75);
		border-radius: var(--radius-small);
		z-index: 3;
	}
</style>
